import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-neurotest',
  templateUrl: './neurotest.component.html',
  styleUrls: ['./neurotest.component.scss']
})
export class NeurotestComponent implements OnInit, OnDestroy {
  protected iframeSrc:string = "https://master.d15vdfcwvaecwx.amplifyapp.com?lang="+this.languageService.getLanguage();
  constructor(private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }
  public companyName: string = environment.company;
  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)) document.getElementsByTagName('main')[0].classList.add('pb-0');
  }
  ngOnDestroy(){
    if(isPlatformBrowser(this.platformId)) document.getElementsByTagName('main')[0].classList.remove('pb-0');
  }

} 
